(() => {
  if (window.sjelfWelcomeInitialized) return;
  window.sjelfWelcomeInitialized = true;
  const dialog = document.querySelector('[data-sjelf-welcome]');
  if (!dialog || !dialog.showModal) return;
  const key = 'sjelf-welcome-v1';
  const memory = new Map();
  const read = (storage, name) => {
    try { return storage.getItem(name); } catch { return memory.get(name); }
  };
  const write = (storage, name, value) => {
    memory.set(name, value);
    try { storage.setItem(name, value); } catch {}
  };
  let local;
  let session;
  try { local = window.localStorage; session = window.sessionStorage; } catch {}
  let visit = { start: Date.now(), paths: [] };
  try {
    const saved = JSON.parse(read(session, key + '-visit') || 'null');
    if (saved && Number.isFinite(saved.start) && Array.isArray(saved.paths)) visit = saved;
  } catch {}
  if (!visit.paths.includes(location.pathname)) visit.paths.push(location.pathname);
  write(session, key + '-visit', JSON.stringify(visit));
  const form = dialog.querySelector('form');
  const pending = read(session, key + '-pending') === form?.id;
  let timer;
  let interacted = false;
  let opened = false;
  let beforeOpen;
  const open = () => {
    if (dialog.open) return;
    beforeOpen = document.activeElement;
    dialog.showModal();
    opened = true;
  };
  const dismiss = () => {
    if (!dialog.open) return;
    write(local, key + '-dismissed', String(Date.now()));
    dialog.close();
    beforeOpen?.focus({ preventScroll: true });
  };
  dialog.querySelectorAll('[data-welcome-close]').forEach(button => button.addEventListener('click', dismiss));
  dialog.addEventListener('cancel', event => { event.preventDefault(); dismiss(); });
  dialog.addEventListener('click', event => {
    if (event.target !== dialog) return;
    const bounds = dialog.getBoundingClientRect();
    if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) dismiss();
  });
  form?.addEventListener('submit', () => write(session, key + '-pending', form.id));
  document.querySelectorAll('form input[name="form_type"][value="customer"]').forEach(input => {
    input.form?.addEventListener('submit', () => write(session, key + '-newsletter-pending', '1'));
  });
  if (dialog.querySelector('[data-welcome-success]')) {
    if (read(session, key + '-newsletter-pending') || pending) {
      write(local, key + '-subscribed', '1');
      write(session, key + '-newsletter-pending', '');
    }
    if (pending) {
      write(session, key + '-pending', '');
      open();
    }
    return;
  }
  if (pending && dialog.querySelector('[data-welcome-errors]')) { open(); return; }
  if (dialog.dataset.designMode === 'true') { open(); return; }
  const visible = el => el && el.getClientRects().length && getComputedStyle(el).visibility !== 'hidden';
  const tryOpen = () => {
    if (opened || !interacted || visit.paths.length < 2 || Number(dialog.dataset.cartCount) > 0) return;
    if (read(local, key + '-subscribed') || read(session, key + '-newsletter-pending')) return;
    const dismissed = Number(read(local, key + '-dismissed')) || 0;
    if (Date.now() - dismissed < 7 * 86400000) return;
    if (Date.now() - visit.start < Number(dialog.dataset.delay) * 1000) return;
    if (document.visibilityState !== 'visible' || document.activeElement?.matches('input, textarea, select, [contenteditable=true]')) return;
    if ([...document.querySelectorAll('dialog[open], [role=dialog][aria-modal=true], #shopify-pc__banner')].some(visible)) return;
    open();
    clearTimeout(timer);
  };
  addEventListener('scroll', () => {
    if (scrollY > 120) { interacted = true; tryOpen(); }
  }, { passive: true });
  document.addEventListener('cart:updated', event => {
    if (event.detail?.cart) dialog.dataset.cartCount = event.detail.cart.item_count;
  });
  timer = setTimeout(tryOpen, Math.max(0, Number(dialog.dataset.delay) * 1000 - (Date.now() - visit.start)));
})();
